(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["countdown-timer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const endDate = '2026-08-31';
    const endTime = '23:59:59';

    const saleEndDateTime = new Date(endDate + ' ' + endTime);

    function updateNumber(id, value) {
      const element = document.getElementById(id);
      const box = element.closest('.time-box');
      const newValue = String(value).padStart(2, '0');

      if (element.textContent === newValue) return;

      element.classList.remove('is-changing');
      box.classList.remove('is-animating');

      void element.offsetWidth;

      element.classList.add('is-changing');
      box.classList.add('is-animating');

      setTimeout(function () {
        element.textContent = newValue;
      }, 165);

      setTimeout(function () {
        element.classList.remove('is-changing');
        box.classList.remove('is-animating');
      }, 500);
    }

    function updateCountdown() {
      const now = new Date().getTime();
      const distance = saleEndDateTime.getTime() - now;

      if (distance < 0) {
        document.querySelector('.countdown-timer').style.display = 'none';
        document.getElementById('countdown-ended').style.display = 'block';
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      updateNumber('days', days);
      updateNumber('hours', hours);
      updateNumber('minutes', minutes);
      updateNumber('seconds', seconds);
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });
  } catch(e) { console.error(e); }
})();

})();
